import { Progress } from '@sortlist-frontend/design-system';
import { useEffect, useState } from 'react';

interface GuideReadingProgressProps {
  label: string;
}

export const GuideReadingProgress = (props: GuideReadingProgressProps) => {
  const { label } = props;
  const [ratio, setRatio] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const root = document.documentElement;
      const max = root.scrollHeight - root.clientHeight;
      setRatio(max > 0 ? root.scrollTop / max : 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Progress
      aria-label={label}
      value={Math.round(ratio * 100)}
      size="xs"
      radius="sm"
      disableAnimation
      classNames={{ base: 'fixed inset-x-0 top-0 z-50 gap-0', track: 'rounded-none bg-transparent' }}
    />
  );
};
